import React from 'react';
import cn from 'classnames';
import {
  Text,
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
  Button,
} from '@fluentui/react-components';
import {
  Document28Regular,
  MoreHorizontal20Regular,
  Open16Regular,
  Link16Regular,
} from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import './ChatMessageAttachment.scss';

interface ChatMessageAttachmentProps {
  filename: string;
  onClick?: () => void;
  onOpenClick?: () => void;
  onCopyLinkClick?: () => void;
}

export const ChatMessageAttachment: React.FC<ChatMessageAttachmentProps> = ({
  filename,
  onClick,
  onOpenClick,
  onCopyLinkClick,
}) => {
  const { t } = useTranslation();

  const inner = (
    <>
      <Document28Regular />
      <Text weight="bold" className="filename">
        {filename}
      </Text>
    </>
  );

  return (
    <div className="ChatMessageAttachment flex items-center gap-1">
      {onClick ? (
        <Button
          appearance="subtle"
          className="clickable"
          onClick={onClick}
          aria-label={t('pc:chat:attachment_click_aria', {
            defaultValue: 'Öffnet Attachment {{filename}}',
            filename,
          })}
        >
          {inner}
        </Button>
      ) : (
        inner
      )}
      {(onOpenClick || onCopyLinkClick) && (
        <Menu>
          <MenuTrigger disableButtonEnhancement>
            <Button
              appearance="subtle"
              icon={<MoreHorizontal20Regular />}
              size="small"
              aria-label={t('pc:chat:attachment_menu_trigger_aria', {
                defaultValue: 'Öffnet ein Menü mit weiteren Aktionen zu dem Attachment',
              })}
            />
          </MenuTrigger>
          <MenuPopover>
            <MenuList>
              {onOpenClick && (
                <MenuItem icon={<Open16Regular />} onClick={onOpenClick}>
                  {t('pc:chat:attachment_open', {
                    defaultValue: 'Öffnen',
                  })}
                </MenuItem>
              )}
              {onCopyLinkClick && (
                <MenuItem icon={<Link16Regular />} onClick={onCopyLinkClick}>
                  {t('pc:chat:attachment_copy_link', {
                    defaultValue: 'Link kopieren',
                  })}
                </MenuItem>
              )}
            </MenuList>
          </MenuPopover>
        </Menu>
      )}
    </div>
  );
};
